// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"531":"557f7a09","787":"729fc0eb"}[chunkId] + ".chunk.js";
};